import http from '@/http/aisea/axios'
const resource = '/constant/resource'

export default {
  fetchCountryCode() {
    return http.get(`${resource}/country_code`)
  },

  fetchPrefecture() {
    return http.get(`${resource}/prefecture`);
  },
  
  fetchPhoneNumber() {
    return http.get(`${resource}/phone_number`);
  },
}
